import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export default function menuFunctionality() {
  moveContentIntoProductNode();
  movePhoneIconToTopHeaderRight();
  addSearchIconToDesktopHeader();
  addClickEventToSearchIcon();
  convertMenuNodeIntoProductMenuNode('webbshop');
  // Astra-filter som inte slår. Får undersöka, så länge kör vi denna
  replaceSearchPlaceHolders();
}
function addSearchIconToDesktopHeader() {
  var miniCart = document.querySelector('.wl-mini-cart');
  if (!miniCart) return;
  var searchIcon = document.createElement('a');
  searchIcon.href = '#';
  searchIcon.classList.add('wl-search-icon');
  searchIcon.innerHTML = '<img src="' + page_urls.site_uri + '/img/search.svg" alt="sökikon" />';
  miniCart.before(searchIcon);
}
function addClickEventToSearchIcon() {
  var headerSearchIcon = document.querySelector('.wl-search-icon');
  if (!headerSearchIcon) return;
  headerSearchIcon.addEventListener('click', function () {
    document.querySelector('.mobile-menu-toggle-icon').click();
    document.querySelector('.wl-dropdown-menu__desktop .search-field').focus();
  });
}
function movePhoneIconToTopHeaderRight() {
  var phoneIcon = document.querySelector('.wl-dropdown-menu__desktop .phone-number__link');
  var miniCart = document.querySelector('.wl-mini-cart');
  if (!phoneIcon || !miniCart) return;
  miniCart.before(phoneIcon);
}
function convertMenuNodeIntoProductMenuNode(nodeName) {
  var productNodes = _toConsumableArray(document.querySelectorAll('#ast-desktop-header .wl-menu-main .menu-link'));
  var productNode = null;
  var productNodeSubmenu = null;
  var _iterator = _createForOfIteratorHelper(productNodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      if (node.textContent.trim().toLowerCase() === nodeName) {
        productNode = node.parentNode;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!productNode) return;
  productNodeSubmenu = productNode.querySelector(':scope > ul');
  if (!productNodeSubmenu) return;
  cloneSearchBarIntoProductNode(productNodeSubmenu);
  placeSubMenuListItemsInContainer(productNodeSubmenu);
  productNodeSubmenu.classList.add('wl-product-sub-menu');
  return productNodeSubmenu;
}
function moveContentIntoProductNode() {
  var productMenuPuffs = document.querySelector('.product-menu__puffs');
  var productMenuBtns = document.querySelector('.product-menu__btns');
  if (!productMenuPuffs || !productMenuBtns) return;
  var productNodeSubmenu = convertMenuNodeIntoProductMenuNode('produkter');
  if (!productNodeSubmenu) return;
  if (productMenuPuffs) {
    productNodeSubmenu.appendChild(productMenuPuffs);
    productMenuPuffs.style.display = 'flex';
    productMenuPuffs.classList.add('wl-moved');
  }
  if (productMenuBtns) {
    productNodeSubmenu.appendChild(productMenuBtns);
    productMenuBtns.style.display = 'grid';
    productMenuBtns.classList.add('wl-moved');
  }
}
function placeSubMenuListItemsInContainer(productNodeSubmenu) {
  var menuItems = productNodeSubmenu.querySelectorAll(':scope > .menu-item');
  var menuItemContainer = document.createElement('div');
  menuItemContainer.classList.add('wl-product-list-item-container');
  menuItemContainer.append.apply(menuItemContainer, _toConsumableArray(menuItems));
  productNodeSubmenu.appendChild(menuItemContainer);
}
function cloneSearchBarIntoProductNode(productNodeSubmenu) {
  var clonedSearchNode = document.querySelector('.wl-search').cloneNode(true);
  clonedSearchNode.classList.add('wl-moved');
  productNodeSubmenu.appendChild(clonedSearchNode);
}
function replaceSearchPlaceHolders() {
  var searchFields = _toConsumableArray(document.querySelectorAll('.search-field'));
  var _iterator2 = _createForOfIteratorHelper(searchFields),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var searchField = _step2.value;
      searchField.placeholder = 'Sök produkter...';
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}